module.exports = __webpack_public_path__ + "media/images/pic/hero-6dd370b265c0fba27ec48cf1d046422a.webp";